import React from 'react';
import '../../css/web/AdminLoginPg.css';
import '../../css/Common.css';
import {FiUser} from 'react-icons/fi'
import {AiOutlineLock} from "react-icons/ai";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Button from "react-bootstrap/Button";
import {useState} from "react"
import axios from '../../services/axiosInstance';
import MsgConfirmModal from "../../components/web/modal/MsgConfirmModal";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import {useDispatch} from "react-redux";
import { setUserInfo } from '../../store/UserSlice';
import imgLogo from "../../assets/img/btorage_only_img_logo.png";

function AdminLoginPg() {

    //region 다크모드

    const [theme] = useTheme();

    //endregion

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [id, setId] = useState("");
    const [password, setPassword] = useState("");
    const location = useLocation();

    const [userOutErrorMsg, setUserOutErrorMsg] = useState(false);
    const [mailDuplErrorMsg, setMailDuplErrorMsg] = useState(false);
    const [accountTypeErrorMsg, setAccountTypeErrorMsg] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState(false);

    const [lgWaitingSt, setLgWaitingSt] = useState(false);
    const lgRegiWaitingMsg = "가입승인이 완료되지 않은 계정입니다."
    const [isLoading, setIsLoading] = useState(false);

    const handleChange_email = (e) => {
        setId(e.target.value);
    }
    const handleChange_password = (e) => {
        setPassword(e.target.value);
    }

    const confirmModalCloseFn = (() => {
        setLgWaitingSt(false);
    })

    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {
            loginCheck().then();
        }
    };

    const loginCheck = async () => {
        setIsLoading(true);

        if (!id || !password) {
            setLoginErrorMsg(true);
            setIsLoading(false);
            return;
        }

        try {
            const joinVerResponse = await axios.get(`/member/joinVerFl/${id}`);
            if (!joinVerResponse.data) {
                setLgWaitingSt(true);
            } else if (joinVerResponse.data) {
                const loginResponse = await axios.post("/member/login", {
                    id: id,
                    password: password,
                    loginPath: location.pathname,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                const data = loginResponse.data;
                if (data.loginErrorType === '0') {
                    console.log('탈퇴처리 된 계정입니다');
                    setUserOutErrorMsg(true);
                    return;
                } else if (data.loginErrorType === '1') {
                    console.log('다른 수단으로 가입된 계정입니다');
                    setMailDuplErrorMsg(true);
                    return;
                } else if (data.loginErrorType === '2') {
                    console.log('계정 유형이 다릅니다');
                    setAccountTypeErrorMsg(true);
                    return;
                }

                const userInformation = {
                    ...data,
                    token: loginResponse.headers['authorization'],
                    id: id,
                    userType: data.userType,
                };

                localStorage.setItem('adminToken', loginResponse.headers.get('Authorization'));
                localStorage.setItem('adminLastLoginTime', new Date().toISOString());

                dispatch(setUserInfo(userInformation));
                navigate("/btcorpad");
            }
        } catch (error) {
            setLoginErrorMsg(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-login" data-theme={theme}>
            <div className="login-main font-t-cont">
                <div className="login-sub">
                    <div className="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-54">
                        <form className="login100-form validate-form">
                            <div className="login100-form-title c-def">
                                <img alt="mainLogo" style={{width:"28px", height:"45px", marginRight: "10px", marginBottom: "5px"}} src={imgLogo}/>
                                <strong className="font-s-33">Administrator Login</strong>
                            </div>
                            <div className="wrap-input100 validate-input m-b-23" data-validate="Username is reauired">
                                <input className="input100 user-input" type="text" name="username" placeholder="아이디를 입력하세요" autoComplete="nope"
                                       onChange={handleChange_email} onKeyDown={handleOnKeyPress}/>
                                <span className="focus-input100">
                                    <i><FiUser className="ad-join-i-con"/></i>
                                </span>
                            </div>
                            <div className="wrap-input100 validate-input" data-validate="Password is required">
                                <input className="input100 user-input" type="password" name="pass" placeholder="비밀번호를 입력하세요" autoComplete="nope"
                                       onChange={handleChange_password} onKeyDown={handleOnKeyPress}/>
                                <span className="focus-input100">
                                    <i><AiOutlineLock className="ad-join-i-con"/></i>
                                </span>
                            </div>
                            <div className="JoinErrorMsg" style={{height: "50px"}}>
                                {loginErrorMsg && <p className="JoinErrMsg">&nbsp;아이디 또는 비밀번호를 확인해주세요</p>}
                                {userOutErrorMsg && <p className="JoinErrMsg">&nbsp;탈퇴처리 된 계정입니다</p>}
                                {mailDuplErrorMsg && <p className="JoinErrMsg">&nbsp;다른 수단으로 가입된 계정입니다</p>}
                                {accountTypeErrorMsg && <p className="JoinErrMsg">&nbsp;계정유형이 다릅니다</p>}
                            </div>
                            <div className="m-a-join-findPw-container">
                                <div onClick={()=> navigate("/btcorpad-join")} className="m-a-join-text font-t-cont text-active c-point">
                                    <p className="font-t-cont">가입하기</p>
                                </div>
                                <div className="m-a-vertical-solid"></div>
                                <div onClick={()=> navigate("/btcorpad-pwFind")} className="m-a-findPw-text font-t-cont text-active c-point">
                                    <p className="font-t-cont">비밀번호찾기</p>
                                </div>
                            </div>
                            <div className="login-sub-form-btn font-t-cont">
                                {theme === "light" ?
                                    <div className="JoinButton acc-submit light wd-100pc">
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                            <Button variant="primary" id="accSubmitBt" onClick={() => {loginCheck();}} className="border-rd4 font-c-fff">
                                                {isLoading ? (
                                                    <div className="user-center">
                                                        <div className="spinner"></div>
                                                    </div>
                                                ) : (
                                                    "Login"
                                                )}
                                            </Button>
                                    </div>
                                    :
                                    <div className="wrap-login100-form-btn dark">
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                            <Button className="ad-login-btn border-rd4" onClick={() => {loginCheck();}} >
                                                {isLoading ? (
                                                    <div className="user-center">
                                                        <div className="spinner"></div>
                                                    </div>
                                                ) : (
                                                    "Login"
                                                )}
                                            </Button>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
                {lgWaitingSt ? <MsgConfirmModal lgWaitingSt={lgWaitingSt} confirmModalCloseFn={confirmModalCloseFn} lgRegiWaitingMsg={lgRegiWaitingMsg}/> : null}
            </div>
        </div>
    );
}

export default AdminLoginPg
